import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
export const PersonTagOptionValues = [
  "ESCALATIONS",
  "INVOICING",
  "PERMITTING",
  "PRIMARY",
  "PRODUCTION",
  "PROFESSIONAL_REFERENCE",
  "PROJECT_MANAGER",
  "QUOTING",
  "SCHEDULING",
  "SITE_INSPECTOR",
  "HOMEOWNER",
  "SPOUSE",
  "FAMILY_MEMBER",
  "EXTERNAL_ROOFER",
  "INSURANCE_AGENT",
  "TENANT",
  "OTHER",
] as const;
/**
 * Use this if you need to zod parse it
 */
export const PersonTagOptionSchema = z.enum(PersonTagOptionValues);
/**
 * Use this if you need to use the literal value
 */
export const PersonTagOption = PersonTagOptionSchema.enum;
/**
 * Use this if you need to use the type
 */
export type PersonTagOption = z.infer<typeof PersonTagOptionSchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const PersonTagOptionDisplayNames: Record<PersonTagOption, string> = {
  PRIMARY: "Primary",
  QUOTING: "Quoting",
  PERMITTING: "Permitting",
  SCHEDULING: "Scheduling",
  SITE_INSPECTOR: "Site inspector",
  PRODUCTION: "Production",
  PROFESSIONAL_REFERENCE: "Professional reference",
  PROJECT_MANAGER: "Project manager",
  ESCALATIONS: "Escalations",
  INVOICING: "Invoicing",
  HOMEOWNER: "Homeowner",
  SPOUSE: "Spouse",
  FAMILY_MEMBER: "Family member",
  EXTERNAL_ROOFER: "External roofer",
  INSURANCE_AGENT: "Insurance agent",
  TENANT: "Tenant",
  OTHER: "Other",
} as const;

export const HomeownerContactPersonTagOptionValues = [
  "SPOUSE",
  "FAMILY_MEMBER",
  "EXTERNAL_ROOFER",
  "INSURANCE_AGENT",
  "TENANT",
  "OTHER",
] as const satisfies PersonTagOption[];

export const ContractorContactPersonTagOptionValues = [
  "ESCALATIONS",
  "INVOICING",
  "PERMITTING",
  "PRIMARY",
  "PRODUCTION",
  "PROFESSIONAL_REFERENCE",
  "PROJECT_MANAGER",
  "QUOTING",
  "SCHEDULING",
  "SITE_INSPECTOR",
] as const satisfies PersonTagOption[];

export const TodaysActionsPersonTagOptionValues = [
  "QUOTING",
  "PERMITTING",
  "SCHEDULING",
  "PRODUCTION",
] as const satisfies PersonTagOption[];
